export default __webpack_public_path__ + "static/media/boa_round_logo.56c83899.png";